export const components = {
  emptyState: {
    primaryTitle: 'Ops!',
    primaryText: "Non c'è ancora nulla qui…",
    secondaryTitle: 'Niente da mostrare',
    secondaryText: 'Purtroppo non ci sono elementi da mostrare in base ai filtri applicati…'
  },
  filters: {
    all: 'Tutto',
    search: 'Cerca',
    priceRange: 'Intervallo di prezzo {currency}',
    minValue: 'Il valore minimo è {val}!',
    maxValue: 'Il valore massimo è {val}!',
    reset: 'Resetta',
    apply: 'Applica'
  },
  comments: {
    reply: 'Rispondi',
    loadMore: 'Carica altro',
    edited: 'Modificato',
    noComments: 'Non ci sono ancora commenti',
    leaveFirstComment: 'Puoi lasciare il primo'
  },
  curtain: {
    close: 'Chiudi'
  },
  photoPreview: {
    close: 'Chiudi'
  },
  photoCropper: {
    back: 'Indietro',
    save: 'Salva'
  },
  rightSidebar: {
    in: 'in'
  },
  pushPrompt: {
    title: '“{appName}” vorrebbe inviarti notifiche',
    description:
      "Le notifiche possono includere avvisi, suoni e badge dell'icona. Questi possono essere configurati nelle impostazioni.",
    later: 'Chiedimi più tardi',
    neverLater: 'Non chiedere più',
    allow: 'Consenti'
  },
  inAppPush: {
    attachment: 'Allegato'
  },
  installPrompt: {
    android: {
      install: 'Installa',
      description:
        "Per un'esperienza senza soluzione di continuità non è necessario utilizzare un browser. Installalo semplicemente come un'app.",
      press: 'Premi',
      andSelect: 'e seleziona',
      orSimply: 'o semplicemente',
      description2: 'clicca sul pulsante Installa qui sotto',
      notNow: 'Non ora'
    },
    ios: {
      justTap: 'Basta toccare',
      buttonInBrowser: 'pulsante nel tuo browser',
      addToHomeScreen: 'Seleziona "Aggiungi alla schermata Home"',
      appWillBeInstalled: "L'app verrà installata sul tuo telefono"
    },
    installApp: 'Installa app',
    useWeb: 'Usa la versione web'
  },
  footer: {
    more: 'Menu'
  },
  menu: {
    installApp: 'Installa app',
    menu: 'Menu',
    close: 'Chiudi'
  },
  404: {
    whoops: 'Ops!',
    description:
      "Sembra che la pagina non esista o forse non hai accesso ad essa. Per ulteriori dettagli, contatta il proprietario dell'app.",
    ok: 'OK'
  },
  relatedUsers: {
    seeall: 'Visualizza tutto'
  },
  networkingCurtain: {
    'newOneOnOne': 'Nuovo 1:1',
    'details': 'Dettagli',
    'coverMessage': 'Messaggio di copertura',
    'location': 'Posizione',
    'duration': 'Durata',
    '15min': '15 min',
    '30min': '30 min',
    '45min': '45 min',
    '60min': '60 min',
    'timeSlot': 'Fascia oraria',
    'sendInvitation': 'Invia invito',
    'success': 'Successo',
    'invitationSent':
      "Hai inviato con successo l'invito a una riunione 1:1. Vuoi rimanere su questa pagina o navigare verso tutte le tue riunioni 1:1 programmate?",
    'seeAll': 'Vedi tutte le riunioni 1:1',
    'stayHere': 'Rimani qui'
  },
  networking: {
    level: {
      1: 'Non pronto per fare networking. Nessuna attività o coinvolgimento significativo.',
      2: 'Raramente attivo o manca di dettagli chiave nel profilo, rendendo difficile connettersi con gli altri.',
      3: 'Profilo completo con foto e online, completamente pronto per iniziare a fare networking.',
      4: 'Costruendo slancio - ha avviato almeno una connessione nelle ultime 6 ore.',
      5: 'Un maestro del networking - risponde attivamente alle richieste e interagisce con gli altri nelle ultime 6 ore.'
    }
  },
  time: {
    days: 'g',
    hours: 'h',
    minutes: 'm',
    seconds: 's',
    startsIn: 'tra',
    Today: 'Oggi',
    today: 'oggi',
    Tomorrow: 'Domani',
    tomorrow: 'domani',
    Yesterday: 'Ieri',
    yesterday: 'ieri',
    startingNow: 'inizia ora'
  },
  daysMonths: {
    months: "['Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno','Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre']",
    monthsShort: "['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic']",
    weekdays: "['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato']",
    weekdaysShort: "['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab']",
    weekdaysMin: "['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa']"
  },
  badges: {
    legend: 'Legendary Networker',
    push: 'Online and Trusted',
    leader: 'Leaderboard Champ',
    meetmaster: '1:1 Meeting Master',
    connector: '3-Time Connector',
    legend_description:
      'Raggiungi il livello Leggenda almeno una volta, facendo networking attivo e creando connessioni significative.',
    push_description: "Abilita le notifiche push per rimanere reattivo e non perdere mai un'opportunità.",
    leader_description: 'Arriva almeno una volta tra il 10 % migliore della classifica.',
    meetmaster_description: "Inizia o rispondi ad almeno una richiesta di riunione 1:1 nell'app.",
    connector_description: "Stabilisci almeno tre connessioni tramite l'app durante i componenti."
  }
}
